import { Badge } from '../ui/badge'

export function ReadOnlyConversationBadge() {
  return (
    <Badge variant="secondary" className="px-1.5 py-0 text-10 leading-4">
      View only
    </Badge>
  )
}
